import { render } from "./ProductHotListSetting.vue?vue&type=template&id=0b2b4cb3&scoped=true"
import script from "./ProductHotListSetting.vue?vue&type=script&lang=js"
export * from "./ProductHotListSetting.vue?vue&type=script&lang=js"

import "./ProductHotListSetting.vue?vue&type=style&index=0&id=0b2b4cb3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2b4cb3"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/ProductHotListSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b2b4cb3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b2b4cb3', __exports__)) {
    api.reload('0b2b4cb3', __exports__)
  }
  
  module.hot.accept("./ProductHotListSetting.vue?vue&type=template&id=0b2b4cb3&scoped=true", () => {
    api.rerender('0b2b4cb3', render)
  })

}


export default __exports__